var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGoogleIcon = function SvgGoogleIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#google-icon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4285F4",
    d: "M8 6.547v3.098h4.305a3.7 3.7 0 0 1-1.607 2.407l2.596 2.015c1.513-1.396 2.386-3.447 2.386-5.884q-.001-.85-.146-1.636z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34A853",
    d: "m3.516 9.523-.585.449-2.073 1.614C2.174 14.197 4.872 16.001 8 16.001c2.16 0 3.97-.713 5.294-1.935l-2.596-2.014c-.713.48-1.622.77-2.698.77-2.08 0-3.848-1.403-4.48-3.294z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FBBC05",
    d: "M.858 4.414A7.9 7.9 0 0 0 0 8c0 1.295.313 2.51.858 3.586 0 .007 2.662-2.066 2.662-2.066-.16-.48-.255-.989-.255-1.52 0-.53.095-1.04.255-1.52z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EA4335",
    d: "M8 3.185c1.178 0 2.225.408 3.062 1.193l2.29-2.29C11.963.792 10.16 0 8 0 4.872 0 2.174 1.796.858 4.415L3.52 6.48C4.152 4.59 5.92 3.185 8 3.185"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "google-icon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgGoogleIcon;